import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    this.initialResponse = this.responseTarget.textContent;
  }

  connect() {}

  static targets = ['content', 'response'];

  static values = {
    clipboardactive: Boolean,
  };

  copy() {
    navigator.clipboard.writeText(this.contentTarget.textContent);

    this.setClipboardActiveValue();
    this.setResponse();
  }

  setClipboardActiveValue() {
    this.clipboardactiveValue = true;
    setTimeout(() => {
      this.clipboardactiveValue = false;
      this.setResponse();
    }, 500);
  }

  setResponse(content) {
    if (this.clipboardactiveValue) {
      this.responseTarget.innerHTML = 'Kopiert!';
    } else {
      this.responseTarget.innerHTML = this.initialResponse;
    }
    this.responseTarget.classList.toggle(
      'shadow-light',
      this.clipboardactiveValue
    );
    this.responseTarget.classList.toggle(
      'bg-lemon',
      this.clipboardactiveValue
    );
    this.responseTarget.classList.toggle(
      'text-black',
      this.clipboardactiveValue
    );
  }
}
